import { PUT_INFO_APPLY_START } from '../../types';

export const put_info_apply = (payload) => ({
  type: PUT_INFO_APPLY_START,
  payload,
});
